module.exports = __webpack_public_path__ + "img/business-solutions-hero-tablet.fcb13698.webp";